import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
let SensibleService = class SensibleService {
    constructor(http) {
        this.http = http;
        this.cargadoSensible = true;
        this.sensible = [];
        this.sensibleRFL = [];
        this.sensibleRFC = [];
        this.sensibleRFP = [];
        this.sensibleRCL = [];
        this.sensibleRCC = [];
        this.sensibleRCP = [];
        this.cargarAntipigmanto();
    }
    cargarAntipigmanto() {
        return new Promise((resolve, reject) => {
            this.http.get('assets/data/dataLineas.json')
                .subscribe((resp) => {
                this.sensible = resp;
                this.sensibleRFL = this.sensible[6].rutinafacial.limpieza;
                this.sensibleRFC = this.sensible[6].rutinafacial.cuidado;
                this.sensibleRFP = this.sensible[6].rutinafacial.proteccion;
                this.sensibleRCL = this.sensible[6].rutinacorporal.limpieza;
                this.sensibleRCC = this.sensible[6].rutinacorporal.cuidado;
                this.sensibleRCP = this.sensible[6].rutinacorporal.proteccion;
                setTimeout(() => {
                    this.cargadoSensible = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    }
};
SensibleService.ctorParameters = () => [
    { type: HttpClient }
];
SensibleService = tslib_1.__decorate([
    Injectable({
        providedIn: 'root'
    })
], SensibleService);
export { SensibleService };
//# sourceMappingURL=sensible.service.js.map